export interface User {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  enabled: boolean;
  realmRoles: UserRole[];
}

export type UserRole =
  | 'cdt-assistant-de-production'
  | 'cdt-administration-du-personnel'
  | 'cdt-responsable-exploitation'
  | 'cdt-directeur-rh'
  | 'cdt-responsable-rh'
  | 'cdt-responsable-paie'
  | 'cdt-directeur-agence'
  | 'cdt-directeur-admin-financier'
  | 'cdt-directeur-general'
  | 'cdt-directeur-production'
  | 'cdt-process-manager';

export const realmRoles: UserRole[] = [
  'cdt-assistant-de-production',
  'cdt-administration-du-personnel',
  'cdt-responsable-exploitation',
  'cdt-responsable-paie',
  'cdt-directeur-rh',
  'cdt-responsable-rh',
  'cdt-directeur-agence',
  'cdt-directeur-admin-financier',
  'cdt-directeur-general',
  'cdt-directeur-production',
];

/**
 * Régler les processus CDT — aujourd'hui les notifications — relève du directeur général et du
 * directeur RH ; le rôle `cdt-process-manager` en donne le droit à une autre personne, et n'habilite
 * qu'à cela (RG-notification-droit-de-regler). Il n'entre pas dans `realmRoles` : il ne désigne
 * aucune fonction.
 */
export const processSettingsEditorRoles: UserRole[] = [
  'cdt-directeur-general',
  'cdt-directeur-rh',
  'cdt-process-manager',
];
